import React, { useState, useEffect, useRef } from "react";
import ScheduleTestingSearch from "./ScheduleTestingSearch";
import Samples from "../sample_reporting/Samples";
import ScheduleTestingForm from "./ScheduleTestingForm";
import { fetchSamples } from "../sample_reporting/Utils/SamplesFetch";

export default function ScheduleTesting({ laboratory_company_id }) {
  const searchFormRef = useRef({});
  const [sampleList, setSampleList] = useState(null);
  const [searchTime, setSearchTime] = useState(null);

  const updateSampleList = (sampleList) => {
    setSampleList(sampleList);
    setSearchTime(new Date());
  };

  const loadSelectedSamples = (sample_ids) => {
    fetchSamples({
      sample_ids,
      include_scheduling_information: true,
    }).then(updateSampleList);
  };

  return (
    <div>
      <ScheduleTestingSearch
        onSearch={updateSampleList}
        ref={searchFormRef}
        laboratory_company_id={laboratory_company_id}
      />
      {sampleList && (
        <div style={{ marginTop: 20 }}>
          <Samples
            key={searchTime}
            sample_list={sampleList}
            showAttributes={false}
            clientView={false}
            reloadData={() => searchFormRef.current.search()}
            showContractedTechniques={false}
            showScheduleableTechniques={true}
            ToolbarComponent2={ScheduleTestingForm}
            loadSelectedSamples={loadSelectedSamples}
            view="scheduling"
          />
        </div>
      )}
    </div>
  );
}
